import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';

const CarouselDataProvider = (props) => {
  const {
    render,
    resourceId,
    allResources,
    filteredResources,
    hasFilteredResources,
    loadingFilteredResources,
    router,
    filteredResourcesLabel,
  } = props;
  const {
    location: { pathname, query },
  } = router;
  const { apd } = query;
  const [activeLink, setActiveLink] = useState(null);
  const [items, setItems] = useState(null);
  const lastFilteredActiveResource = useRef();

  useEffect(() => {
    if (activeLink === 'filtered') {
      lastFilteredActiveResource.current = apd;
    }
  }, [activeLink, apd]);

  useEffect(() => {
    if (!loadingFilteredResources && hasFilteredResources) {
      setActiveLink('filtered');
      setItems(filteredResources);
    } else if (!loadingFilteredResources && !hasFilteredResources) {
      setActiveLink('all');
      setItems(allResources);
    }
  }, [loadingFilteredResources, hasFilteredResources]);

  const onSetFilteredItems = () => {
    if (!lastFilteredActiveResource.current) {
      router.push({
        pathname,
        query: {
          ...query,
          apd: filteredResources[0].url,
        },
      });
    }
    setActiveLink('filtered');
    setItems(filteredResources);
  };

  const onSetAllItems = () => {
    setActiveLink('all');
    setItems(allResources);
  };

  if (!items) return null;

  const navigationComponent = hasFilteredResources && (
    <div className="CarouselDataToggle--container">
      <AccessibilityWrapper>
        <span
          className={cn('toggle-item', {
            'is-active': activeLink !== 'filtered',
          })}
          tabIndex={0}
          role="button"
          onClick={onSetFilteredItems}
        >
          {filteredResourcesLabel}
        </span>
      </AccessibilityWrapper>
      <AccessibilityWrapper>
        <span
          className={cn('toggle-item', 'toggle-item-all', {
            'is-active': activeLink !== 'all',
          })}
          tabIndex={0}
          role="button"
          onClick={onSetAllItems}
        >
          All Videos
        </span>
      </AccessibilityWrapper>
    </div>
  );

  const foundResource = items.find(({ url }) => url === apd);
  if (!foundResource && lastFilteredActiveResource.current) {
    router.push({
      pathname,
      query: {
        ...query,
        apd: lastFilteredActiveResource.current,
      },
    });
    return null;
  } else if (!foundResource && !lastFilteredActiveResource.current) {
    /**
     * Backwards compatibility
     * */
    setItems(allResources);
    setActiveLink('all');
    return null;
  }

  return render({
    navigationComponent,
    activeResourceId: resourceId,
    items,
    activeLink,
  });
};

CarouselDataProvider.propTypes = {
  render: PropTypes.func.isRequired,
  resourceId: PropTypes.string.isRequired,
  allResources: PropTypes.array.isRequired,
  hasFilteredResources: PropTypes.bool,
  loadingFilteredResources: PropTypes.bool,
  filteredResources: PropTypes.array,
  router: PropTypes.object.isRequired,
  filteredResourcesLabel: PropTypes.string.isRequired,
};

CarouselDataProvider.defaultProps = {
  hasFilteredResources: false,
  loadingFilteredResources: false,
  filteredResources: [],
};

export default CarouselDataProvider;
